import { createSimpleForm } from 'pages/common/Form';
import { createItemPage } from 'pages/common/ItemPage';

import { selectors, actions } from 'domain/surface';
import { createFormConfig } from 'lib/helpers';

import { columns } from 'fields/surface';

const { item } = selectors;
const { updateItemAction } = actions;

export const editableFields = ['description', 'order', 'rank', 'values'];

export default createItemPage({
  name: 'surface',
  connections: {
    item,
  },
  titleFn: data => data.get('description'),
  config: {
    basicInfo: [
      createFormConfig(columns.select(...editableFields)),
      [],
      columns.select('id','createdDate','updatedDate'),
    ],
  },
  Form: createSimpleForm({
    form: 'surfaceForm',
    action: updateItemAction,
  }),
});
